module.exports = __webpack_public_path__ + "static/media/java.da974b45.svg";